<div class="custom-security-link">
    <a [routerLink]="['/mail-merge-template-list']" target="_blank">Mail Merge Templates</a>
</div>
<div class="margin-all-area">
    <div class="wraper-main-section">
        <div class="global-card-section">
            <div class="top-txtmsg">
                <div class="global-header-section">
                    <div class="svg-icon-panel"><img src="../../../../assets/documentstitle.svg" class="mr-1" />Engage Services Contracts</div>
                    <div class="header-button-panel">
                        <div class="button-wrapper">
                            <!--<button class="btn btn-primary" type="button" (click)="resetGridSetting(); inputRepSearch.value = ''">Reset Grid Setting</button>-->
                            <input class="" placeholder="Search in all columns..." kendoTextBox (input)="onRepSettingFilter($event.target.value)" #inputRepSearch />
                            <button type="button" [hidden]="roleFeaturePermissions?.create == false" matTooltip="New" class="icon-btn" (click)="addNew()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                                <span class="btn-text-new">New</span>
                                <span class="btn-text">Add</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="global-body-section">
                    <div class="message-info">
                        <span>Total Records found: {{repSettingsData?.length}}</span>
                    </div>
                    <form [formGroup]="repSettingForm" (ngSubmit)="repSettingFormSubmit()" *ngIf="isEnableEdit">
                        <div class="wraper-body-panel">
                            <div class="wraper-body-left">
                                <div class="cards-body-section">
                                    <div class="cards-colunm-left">
                                        <span class="control-label"> Engage Services Contract Title</span>
                                    </div>
                                    <div class="cards-colunm-right">
                                        <input [ngClass]="{'has-error': repSettingFrm.contractName.errors && (repSettingFrm.contractName.touched || repSettingFrm.contractName.dirty)}" type="text" class="txtStandard" formControlName="contractName" />
                                        <div *ngIf="repSettingFrm.contractName.errors && (repSettingFrm.contractName.touched || repSettingFrm.contractName.dirty)">
                                            <div class="login-error" *ngIf="repSettingFrm.contractName.errors.required">Contract name is required </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cards-body-section">
                                    <div class="cards-colunm-left">
                                        <span class="control-label spantext">Mail Merge Template</span>
                                    </div>
                                    <div class="cards-colunm-right">
                                        <select class="form-control" formControlName="mailMergeTemplateID" [ngStyle]="{'margin-bottom': (repSettingFrm.contractName.errors && (repSettingFrm.contractName.touched || repSettingFrm.contractName.dirty)) ? '0px' : '0'}">
                                            <option value="0"> -Select- </option>
                                            <option *ngFor="let item of mailMergeTemplateDropDown" [value]="item.mailMergeTemplateID">{{item.templateName}}</option>
                                        </select>
                                        <div *ngIf="(repSettingFrm.mailMergeTemplateID.touched) && (repSettingFrm.mailMergeTemplateID.value == 0)">
                                            <div class="login-error">Mail Merge Template is required </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cards-body-section">
                                    <div class="cards-colunm-left">
                                        <span class="control-label spantext">Email Template</span>
                                    </div>
                                    <div class="cards-colunm-right">
                                        <select class="form-control" formControlName="emailTemplateID" [ngStyle]="{'margin-bottom': (repSettingFrm.contractName.errors && (repSettingFrm.contractName.touched || repSettingFrm.contractName.dirty)) ? '0px' : '0'}">
                                            <option value="0"> -Select- </option>
                                            <option *ngFor="let item of emailTemplateDropDown" [value]="item.value">{{item.text}}</option>
                                        </select>
                                        <div *ngIf="(repSettingFrm.emailTemplateID.touched) && (repSettingFrm.emailTemplateID.value == 0)">
                                            <div class="login-error">Email Template is required </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cards-body-section">
                                    <div class="cards-colunm-left">
                                        <span class="control-label"> Connect with User Seat </span>
                                    </div>
                                    <div class="cards-colunm-right">
                                        <input type="checkbox" class="checkbox" formControlName="isConnectwithUser" />
                                    </div>
                                </div>
                                <div class="cards-body-section">
                                    <div class="cards-colunm-left"></div>
                                    <div class="cards-colunm-right">
                                        <button class="btn btn-primary" [disabled]="showSpinner" [hidden]="roleFeaturePermissions?.create == false || roleFeaturePermissions?.edit == false" type="submit">
                                            <ng-template [ngIf]="buttonTypeOperation!=1">Save</ng-template>
                                            <ng-template [ngIf]="buttonTypeOperation===1">Saving  <span><i wrapper> </i></span></ng-template>
                                        </button>
                                        <button class="btn btn-cancel" type="button" (click)="cancelRep()"> Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <table mat-table [dataSource]="repSettingsDataSource" class="mat-elevation-z8" matSort (matSortChange)="_localService.setSortState($event, 'rep_setting_grid')">
                        <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                            <ng-container *ngIf="column.field == 'action'; else defaultColumn">
                                <th mat-header-cell *matHeaderCellDef> {{ column.title }} </th>
                                <td mat-cell *matCellDef="let row; let i = index">
                                    <div class="flex-align-panel">
                                        <button (click)="editHandler(i, row )" [hidden]="roleFeaturePermissions?.edit == false" [primary]="true" title="Edit" class="grid-common-btn">
                                            <kendo-icon name="edit"></kendo-icon>
                                        </button>
                                        <!--<button (click)="saveHandler(row)" [primary]="true" title="Update">
                                            <kendo-icon name="check"></kendo-icon>
                                        </button>
                                        <button (click)="cancelHandler()" [primary]="true" title="Cancel">
                                            <kendo-icon name="close"></kendo-icon>
                                        </button>-->
                                    </div>
                                </td>
                            </ng-container>
                            <ng-template #defaultColumn>
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.title }} </th>
                                <td mat-cell *matCellDef="let dataItem; let i = index">
                                    <div class="customer-name" *ngIf="column.field == '$' && column.title == '' "> {{ getSerialNumber(i) }}</div>
                                    <div class="customer-name" *ngIf="column.field == 'contractName'">
                                        <a [routerLink]="['/contract', dataItem.engageSCID]" (click)="_localService.sendContractName(dataItem.contractName)" class="text-primary">{{ dataItem[column.field] }}</a>
                                    </div>
                                    <div class="customer-name" *ngIf="column.field == 'mailMergeTemplateID'"><a [routerLink]="['/template-preview', dataItem.mailMergeTemplateID]" target="_blank" class="text-primary">{{ convertEmailTemplate(dataItem[column.field]) }}</a> </div>
                                    <div class="customer-name" *ngIf="column.field == 'isConnectwithUser'">{{dataItem[column.field]}}</div>
                                </td>
                            </ng-template>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="repSettingsDataDisplayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: repSettingsDataDisplayColumns;"></tr>
                    </table>
                    <mat-paginator *ngIf="repSettingsData?.length > 0" [pageSize]="pageSize"
                                   (page)="_localService.setPageSize($event, 'rep_setting_grid')" [length]="repSettingsData?.length" [pageSizeOptions]="[10, 50, 100,200]"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="loader-body" *ngIf="showSpinner || _gridCnfgService.showSpinner">
    <div class="lds-ripple"><div></div><div></div></div>
</div>
